import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/utenti';
import { selectors, DEFAULT_STATE } from '../reducers/utenti';
import api from '../apis/utenti';

const sagas = helper.createSagas(
    'utenti',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
